module.exports = __webpack_public_path__ + "img/mn.933606d5.svg";